// Permet d'afficher le nombre de colonnes masquées
$(document).on('click', ".dt-button.buttons-columnVisibility", function () {
    const tableElement = $(this).closest('.dataTables_wrapper').find('.dataTable[id]').get(0);
    const keyLocalStorage = getKeyLocalStorage(tableElement);
    getNbrColonneMasquees(keyLocalStorage);
});

function getNbrColonneMasquees(keyLocalStorage) {
    let localStorageDatatable = JSON.parse(localStorage.getItem(keyLocalStorage));
    let nbrColonnesMasquees = localStorageDatatable.columns.filter((col) => {
        return (col.visible === false);
    }).length;

    document.getElementsByClassName("buttons-colvis")[0].children[0].innerHTML = `Masquer colonne (${nbrColonnesMasquees})`;
}

function initTableDatatable(element, options) {
    // #32355 + #18471 : Event pour utiliser nos spinners par défaut
    // Si on veut un comportement différent pour le 'processing.dt' tout en utilisant 'initTableDatatable', recette:
    //      // Enlever le nouveau listener maintenant par défaut:
    //      $(objet_datatable).off('processing.dt.geocentralisDefault');
    //      // Puis y attacher son code personnalisé
    //      $(objet_datatable).on('processing.dt', function () {
    //          ma_fonction();
    //      });
    let datatable_options = $.extend(true, {}, options || {});
    $(element)
        .off('processing.dt.geocentralisDefault')
        .on('processing.dt.geocentralisDefault', function (e, settings, processing) {
            e.stopImmediatePropagation();
            // Utilisation de notre spinner
            (processing ? wait.start : wait.stop)();
        });

    return $(element).DataTable(datatable_options);
}

function refreshDatatables(callback) {
    var idRapport = parseInt($('[name=hid-id-rapport]').val());
    var bool_refresh = true
        if(idRapport === 54) {
            bool_refresh = false
        }
    if (typeof callback === 'undefined') {
        callback = function() {};
    }
    let tables = $.fn.dataTable.fnTables(true);
    $(tables).each(function () {
        if ($(this).dataTable().api().ajax.url()) {
            $(this).dataTable().api().ajax.reload(function () {
                callback(); // Appel de la fonction de rappel une fois le rechargement terminé
            }, bool_refresh);
        }
    });
}

function destroyDataTable(element) {
    if($.fn.DataTable.isDataTable($(element))){
        try {
            $(element).dataTable().fnDestroy();
        }catch (err) {
            // #23326
            switch (err.name) {
                case ("TypeError"):
                    console.log(err);
                     break;
                default: throw err;
            }
        }
    }
}

function destroyDataTableInContainer(selector) {
    var tables = $.fn.dataTable.fnTables(true);
    $(tables).each(function () {
        if($(this).closest(selector).length) {
           destroyDataTable(this);
        }
    });

    trigger_remove_unused_datatable_fixedheader();
}

function destroyDataTables() {
    var tables = $.fn.dataTable.fnTables(true);
    $(tables).each(function () {
        destroyDataTable(this);
    });

    trigger_remove_unused_datatable_fixedheader();
}

function trigger_remove_unused_datatable_fixedheader() {
    remove_unused_datatable_fixedheader(".fixedHeader-floating");
    remove_unused_datatable_fixedheader(".fixedHeader-locked");
}

function remove_unused_datatable_fixedheader(selector) {
    $(selector).each(function () {
        var fh_name = $(this).attr("name");
        if(fh_name && !$("table[name='" + fh_name + "']:not(.fixedHeader-floating):not(.fixedHeader-locked)").length) {
            /* si aucun tableau n'est rataché aux fixed-header, supprimer */
            $(this).parent(".dtfh-floatingparent").remove();
        }
    });
}

$.extend(true, $.fn.dataTable.ext.buttons, {
    colvisRestore: {
        name: 'colvisRestore',
        className: 'buttons-colvisRestore buttons-collection',
        text: 'Restaurer colonnes',
        action: function (e, dt) {
            dt.columns().visible(true, false);
            dt.columns.adjust().draw(false);

            setTimeout(function () {
                updateColvisRestoreButton(dt);

                const tableElement = dt.table().node();
                const keyLocalStorage = getKeyLocalStorage(tableElement);
                getNbrColonneMasquees(keyLocalStorage);
            }, 0);
        }
    }
});

function updateColvisRestoreButton(dt) {
    const btn = dt.button('colvisRestore:name');
    const anyHidden = dt.columns().visible().toArray().includes(false);
    btn.enable(anyHidden);
}

// On enable/disable le bouton au chargement et à chaque changement de visibilité de colonne
$(document).on('init.dt', function (e, settings) {
    const dt = new $.fn.dataTable.Api(settings);
    updateColvisRestoreButton(dt);
    dt.on('column-visibility.dt', function () {
        updateColvisRestoreButton(dt);
    });
});


$.extend(true, $.fn.dataTable.defaults, {
    lengthMenu: [[10, 25, 50, 100, 1000], [10, 25, 50, 100, 1000]],
    fixedHeader: {
        headerOffset: $('.navbar-fixed-top').outerHeight()
    },
    language: {url: datatable_locale_url},
    processing: false,

    // Persist
    stateSave: true,
    stateDuration: -1, // keep forever unless cleared

    stateSaveCallback: function (settings, data) {
        const tableElement = settings.nTable;
        const key = getKeyLocalStorage(tableElement);

        // optional: version to invalidate after schema changes
        data._schemaVersion = 1;

        try {
            localStorage.setItem(key, JSON.stringify(data));
        } catch (e) {
            // storage unavailable or full — ignore silently
        }
    },

    // Load from dt_<username>_<id_rapport> (or fall back to defaults if missing)
    stateLoadCallback: function (settings) {
        const tableElement = settings.nTable;
        const key = getKeyLocalStorage(tableElement);

        try {
            const raw = localStorage.getItem(key);
            return raw ? JSON.parse(raw) : null; // null => DT uses defaults
        } catch (e) {
            return null;
        }
    },

    // Ignore incompatible saved blobs
    stateLoadParams: function (settings, data) {
        if (data && data._schemaVersion !== 1) return false;
    }
});


function getKeyLocalStorage(tableElement) {
    const username = (
        $('#page_content').find('[name="hid-user-id"]').val() ??
        $('#usager_public').val() ??
        $(tableElement).data('username') ??
        'anon'
    ).toString();

    const idRapport =(
        $(tableElement).data('idRapport') ??
        tableElement.id ??
        '0'
    ).toString();

    return `datatable_${username}_${idRapport}`;
}

function datatable_activer_noms_colones(){
    // disponible dans DT 2.0:
    // permets d'étendre l'api DT pour obtenir les noms de colonnes
    $.fn.dataTable.Api.registerPlural( 'columns().names()', 'column().name()', function ( setter ) {
        return this.iterator( 'column', function ( settings, column ) {
            var col = settings.aoColumns[column];

            if ( setter !== undefined ) {
                col.sName = setter;
                return this;
            }
            else {
                return col.sName;
            }
        }, 1 );
    } );
}
